import React from "react";
import { motion } from "framer-motion";

const trustMetrics = [
  {
    title: "We research before we build",
  },
  {
    title: "We focus on clarity and performance",
  },
  {
    title: "We build with SEO in mind from day one",
  },
  {
    title: "We create solutions that support real business use",
  },
  {
    title: "We stay involved after launch",
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 18 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.42,
      ease: "easeOut",
    },
  },
};

export const TrustSection = () => {
  return (
    <section className="relative isolate overflow-hidden bg-[linear-gradient(135deg,#fbfaff_0%,#ffffff_50%,#f5fbff_100%)] py-16 sm:py-20 lg:py-28">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-28 bottom-0 h-80 w-80 rounded-full bg-primary/10 blur-3xl" />
        <div className="absolute -right-24 top-10 h-96 w-96 rounded-full bg-sky-300/16 blur-3xl" />
        <div className="absolute left-[42%] top-1/2 h-[520px] w-[520px] -translate-y-1/2 rounded-full bg-white/70 blur-3xl" />

        <div className="absolute left-8 bottom-12 hidden h-44 w-44 opacity-25 lg:block">
          <div className="h-full w-full bg-[radial-gradient(circle,rgba(124,58,237,0.38)_1px,transparent_1px)] [background-size:13px_13px]" />
        </div>

        <div className="absolute right-12 top-12 hidden h-40 w-40 opacity-20 lg:block">
          <div className="h-full w-full bg-[radial-gradient(circle,rgba(14,165,233,0.38)_1px,transparent_1px)] [background-size:13px_13px]" />
        </div>
      </div>

      <div className="container-custom relative z-10">
        <div className="grid items-center gap-12 lg:grid-cols-[0.88fr_1.22fr] lg:gap-16 xl:gap-20">
          <motion.div
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.35 }}
            transition={{ duration: 0.55, ease: "easeOut" }}
            className="max-w-xl"
          >
            <span className="text-sm font-semibold uppercase tracking-[0.2em] text-primary">
              Why Choose Us
            </span>

            <h2 className="mt-4 font-display text-3xl font-bold leading-tight text-foreground sm:text-4xl lg:text-5xl">
              We Build Around the Business, Not Around a{" "}
              <span className="gradient-text">Template</span>
            </h2>

            <div className="mt-7 h-1 w-16 rounded-full bg-gradient-to-r from-primary to-sky-400" />

            <p className="mt-7 max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg">
              Our work is guided by strategy, practical thinking, and a clear
              understanding of what the business needs to achieve online.
            </p>
          </motion.div>

          <motion.div
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.25 }}
            className="space-y-5 sm:space-y-6"
          >
            {trustMetrics.map((m) => {
              return (
                <motion.div
                  key={m.title}
                  variants={itemVariants}
                  whileHover={{
                    y: -4,
                    transition: { duration: 0.22, ease: "easeOut" },
                  }}
                  className="group relative"
                >
                  <div className="absolute -inset-2 rounded-[1.8rem] bg-primary/10 opacity-0 blur-xl transition-opacity duration-300 group-hover:opacity-100" />

                  <article className="relative overflow-hidden rounded-[1.6rem] border border-border/60 bg-white/90 px-6 py-6 shadow-[0_18px_45px_rgba(15,23,42,0.07)] backdrop-blur-xl transition-all duration-300 group-hover:border-primary/20 group-hover:shadow-[0_24px_60px_rgba(124,58,237,0.13)] sm:px-8 sm:py-7 lg:px-9">
                    <h3 className="font-display text-lg font-semibold leading-snug text-foreground transition-colors duration-300 group-hover:text-primary sm:text-xl lg:text-2xl">
                      {m.title}
                    </h3>
                  </article>
                </motion.div>
              );
            })}
          </motion.div>
        </div>
      </div>
    </section>
  );
};